<template>
  <div class="course-selection">
    <div class="header-section">
      <h1 class="main-title">Revisión y confirmación</h1>
      <p class="subtitle">Revisa y confirma tus cursos</p>
    </div>

    <div class="content-box" id="pdf-content">
      <div class="main-content">
        <div class="details-section">
          <div class="info-card">
            <div class="info-item">
              <div class="info-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                </svg>
              </div>
              <div class="info-content">
                <span class="info-label">Programa</span>
                <span class="info-value">{{ studentInfo.program }}</span>
              </div>
            </div>

            <div class="info-item">
              <div class="info-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              </div>
              <div class="info-content">
                <span class="info-label">Nombre del alumno</span>
                <span class="info-value">{{ studentInfo.name }}</span>
              </div>
            </div>

            <div class="info-item">
              <div class="info-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <div class="info-content">
                <span class="info-label">Sede</span>
                <span class="info-value">{{ studentInfo.location }} *</span>
              </div>
            </div>
          </div>

          <div class="courses-section">
            <h3 class="section-title">Cursos</h3>
            <div class="courses-list">
              <div
                v-for="course in groupedCourses"
                :key="course.name"
                class="course-group"
              >
                <div class="course-header">
                  <div
                    class="course-dot"
                    :style="{ backgroundColor: course.color }"
                  ></div>
                  <div class="course-name">{{ course.name }}:</div>
                </div>
                <div class="course-schedules">
                  <div
                    v-for="(schedule, index) in course.schedules"
                    :key="index"
                    class="course-schedule-item"
                  >
                    {{ schedule }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pricing-section">
            <div class="pricing-item">
              <span class="pricing-label"><b>Total cursos</b></span>
              <span class="pricing-value">${{ formatPrice(pricing.precioSubTotal) }}</span>
            </div>
            <div class="pricing-item discount">
              <span class="pricing-label">Desc. inscripción online ({{ pricing.porcentajeDescuento }}%)</span>
              <span class="pricing-value">-${{ formatPrice(pricing.valorDescuento) }}</span>
            </div>
            <div class="pricing-item discount">
              <span class="pricing-label">Matrícula online</span>
              <span class="pricing-value">${{ formatPrice(pricing.valorMatricula) }}</span>
            </div>
            
            <!-- <div class="pricing-divider"></div>
            <div class="pricing-item total-discount">
              <span class="pricing-label">Total descuento</span>
              <span class="pricing-value">${{ formatPrice(pricing.totalDescuento) }}</span>
            </div> -->
            
            <!-- Fila Monto Programa con asteriscos -->
            <div class="pricing-item monto-programa">
              <span class="pricing-label"><b>Monto Anual de tu programa</b></span>
              <span class="pricing-value"><b>${{ formatPrice(pricing.precioTotal) }} **</b></span>
            </div>
            
            <!-- Separador para cupón aplicado -->
            <div v-if="appliedCoupon && precioOriginalSinCupon" class="pricing-divider"></div>
         
            <!-- Campos del cupón aplicado -->
            <div class="pricing-item coupon-discount" v-if="appliedCoupon && precioOriginalSinCupon">
              <span class="pricing-label">Cupón Aplicado</span>
              <span class="pricing-value">
                <span v-if="getCouponDiscountPercentage() === 100">100%</span>
                <span v-else>Cupón ({{ getCouponDiscountPercentage() }}%)</span>
              </span>
            </div>
            <div class="pricing-item coupon-discount" v-if="appliedCoupon && precioOriginalSinCupon">
              <span class="pricing-label">Descuento Cupón</span>
              <span class="pricing-value">- ${{ formatPrice(getCouponDiscountAmount()) }}</span>
            </div>
          </div>
          <div class ="importante-section">
            <h5 style="color: #966a11; padding-bottom: 10px;">
              <img src="/images/iconos/importante.svg" alt="warning" />
              Importante
            </h5>

            <p style="color: #966a11">
              *La dirección de la sede "Avda. Apoquindo 5142, Las Condes"
              aparecerá por defecto al seleccionar programas Streaming.
            </p>

            <p style="color: #966a11">
              ** El monto obtenido en tu cotización corresponde al valor anual
              de tu programa.
            </p>
          </div>
        </div>

        <div class="summary-section">
          <div class="summary-card">
            <h3 class="section-title">Resumen de tu compra</h3>

            <div class="total-section">
              <div class="total-label">Total a pagar</div>
              <div v-if="appliedCoupon && precioOriginalSinCupon" class="original-price">
                <span class="original-amount">$ {{ formatPrice(precioOriginalSinCupon) }}</span>
              </div>
              <div class="total-amount">$ {{ formatPrice(pricing.precioTotal) }} **</div>
              <p class="pricing-note"> Un asesor le llamará desde un número como este <strong>600 023 XXXX.</strong> (Excepto fines de semana y festivos).</p>
              <p class="pricing-note"> Por favor asegúrese de contestar, ya que el asesor le explicará otras promociones y descuentos disponibles en sedes.</p>
            </div>
            
            <!-- Tag de descuento aplicado -->
            <div v-if="appliedCoupon && precioOriginalSinCupon" class="discount-tag">
              <div class="discount-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 6L9 17l-5-5"/>
                </svg>
              </div>
              <span class="discount-text">
                <span v-if="getCouponDiscountPercentage() === 100">100% DCTO.</span>
                <span v-else>{{ getCouponDiscountPercentage() }}% DCTO.</span>
              </span>
            </div>

            <!-- Coupon Section -->
            <div class="coupon-section no-pdf">
              <div class="coupon-header">
                <img
                  class="icon"
                  src="/images/iconos/black-ticket-discount.svg"
                />
                <span class="coupon-title">
                  {{
                    appliedCoupon
                      ? "Cupón aplicado"
                      : "Agregar cupón de descuento"
                  }}
                </span>
              </div>

              <!-- Loader elegante durante validación -->
              <div v-if="isValidating" class="coupon-validating">
                <div class="spinner-container">
                  <div class="spinner"></div>
                  <span class="validating-text">Validando cupón...</span>
                </div>
              </div>

              <div v-else-if="appliedCoupon" class="applied-coupon">
                <div class="coupon-info">
                  <span class="coupon-code">{{ appliedCoupon }}</span>
                  <button @click="removeCoupon" class="remove-coupon-btn">
                    <img
                      src="/images/featured/close-circle-primary.svg"
                      alt="remove"
                    />
                  </button>
                </div>
              </div>

              <div v-else class="coupon-form">
                <div class="coupon-input-group">
                  <label class="coupon-label">Código de cupón</label>
                  <input
                    v-model="couponCode"
                    type="text"
                    placeholder="Ej: AE2 6DG"
                    class="coupon-input"
                    :disabled="isValidating"
                    @input="couponCode = $event.target.value.toUpperCase()"
                    maxlength="16"
                  />
                </div>
                <div v-if="couponError" class="error-message">
                  El código del cupón ingresado no es válido.
                </div>
                <button
                  @click="applyCoupon"
                  class="coupon-button"
                  :disabled="!couponCode.trim() || isValidating"
                >
                  {{ isValidating ? "Validando..." : "Aplicar" }}
                </button>
              </div>
            </div>
            <PdfGenerator 
                :allData="allData"
                :quote="quote"
              />
              
            <!-- Botón adicional de confirmar compra -->
             
            <div class="additional-confirm-section">
              <p style="padding-bottom: 16px;">Finaliza tu matrícula en dos simples pasos</p>
              <button class="additional-confirm-btn" @click="goToNextStep">
                {{ buttonText }}
              </button>
            </div>
          </div>

          <!-- Why Choose Us Section -->
          <div class="why-choose-card">
            <h3 class="section-title">¿Por qué elegirnos?</h3>
            <ul class="why-choose-list">
              <li>
                <img src="/images/new-version/idea.svg" alt="Puntajes máximos" class="why-choose-icon" />
                <span>Líderes históricos en puntajes máximos.</span>
              </li>
              <li>
                <img src="/images/new-version/book.svg" alt="Plataformas académicas" class="why-choose-icon" />
                <span>Plataformas con información académica, contenidos, ejercitación, evaluaciones y orientación.</span>
              </li>
              <li>
                <img src="/images/featured/teacher-menu.svg" alt="Docentes" class="why-choose-icon" />
                <span>Docentes de excelencia con consulta personalizada.</span>
              </li>
              <li>
                <img src="/images/svgs/contact_support.svg" alt="Acompañamiento" class="why-choose-icon" />
                <span>Acompañamiento académico y vocacional.</span>
              </li>
              <li>
                <img src="/images/svgs/phone_iphone.svg" alt="App PDV LAB" class="why-choose-icon" />
                <span>App Preu PDV LAB con simuladores, videos, 3D con realidad aumentada, libro digital y Tutor IA disponible 24/7 para guiar y enfocar el estudio.</span>
              </li>
            </ul>
          </div>
          
        </div>
      </div>

              <!-- Calendar Section -->
        <div class="calendar-section no-pdf" v-show="showCalendar">
          <h3 class="calendar-title">Horario</h3>
          <WeeklyCalendar
            :selected-courses="calendarSelectedCourses"
            :left-column-materias="allData.step3?.leftColumnMaterias || []"
            :right-column-materias="allData.step3?.rightColumnMaterias || []"
            :read-only="true"
          />
        </div>
      <!-- Botones de navegación -->
      <div class="nav-btns no-pdf" style="margin-top: 100px; margin-bottom: 100px;">
        <button class="back-btn" @click="goToPreviousStep">
          &larr; Volver
        </button>
        <button class="continue-btn" @click="goToNextStep">
          {{ buttonText }} &rarr;
        </button>
      </div>
      <div class="no-pdf">
      </div>
    </div>
  </div>
</template>

<script>
import WeeklyCalendar from "@/components/step3/WeeklyCalendar.vue";
import PdfGenerator from "@/components/step4/PdfGenerator.vue";
import quoteService from "@/services/quoteService";
import { useStepperStore } from "@/store/stepperStore";
import courseColorsStore from '@/store/courseColorsStore'
import { formatFullCourseName } from '@/utils/subjectNameUtils';

export default {
  name: "DataConfirmation",
  props: {
    quote: { type: Object, required: true },
    allData: { type: Object, required: true },
  },
  data() {
    return {
      couponCode: "",
      couponError: false,
      isValidating: false,
      appliedCoupon: null,
      showCalendar: false,
      precioOriginalSinCupon: null, // Precio total antes de aplicar cupón
    };
  },
  setup() {
    const stepperStore = useStepperStore();
    return {
      stepperStore,
    };
  },
  mounted() {
    // Inicializar cupón aplicado desde el store si existe
    if (this.allData.step4?.coupon) {
      this.appliedCoupon = this.allData.step4.coupon;
      
      // Cargar precio original desde el store si existe
      if (this.allData.step4?.precioOriginalSinCupon) {
        this.precioOriginalSinCupon = this.allData.step4.precioOriginalSinCupon;
      }
      
      // Validar automáticamente el cupón al cargar con un pequeño delay
      // para asegurar que el componente esté completamente montado
      this.$nextTick(() => {
        setTimeout(() => {
          this.validateExistingCoupon();
        }, 100);
      });
    }
  },

  watch: {
    // Observar cambios en allData para mantener sincronizado el cupón
    'allData.step4.coupon': {
      handler(newCoupon) {
        
        if (newCoupon && newCoupon !== this.appliedCoupon) {
          this.appliedCoupon = newCoupon;
        } else if (!newCoupon && this.appliedCoupon) {
          this.appliedCoupon = null;
          // Limpiar también el input del cupón cuando se reinicia
          this.couponCode = "";
          this.couponError = false;
        }
      },
      immediate: false // Cambiado a false para evitar conflicto con mounted
    },
    
    // Observar cambios en precioOriginalSinCupon del store
    'allData.step4.precioOriginalSinCupon': {
      handler(newPrecio) {
        if (newPrecio && newPrecio !== this.precioOriginalSinCupon) {
          this.precioOriginalSinCupon = newPrecio;
        } else if (!newPrecio && this.precioOriginalSinCupon) {
          this.precioOriginalSinCupon = null;
        }
      },
      immediate: false
    }
  },
  computed: {
    studentInfo() {
      // Función para limpiar el nombre de la sede
      const cleanLocationName = (locationName) => {
        if (!locationName) return "";
        let cleanName = locationName;
        cleanName = cleanName.replace(/Preuniversitario\s*/gi, '');
        cleanName = cleanName.replace(/Pre Sede\s*/gi, '');
        return cleanName.trim();
      };

      return {
        program: this.allData.step1?.program?.name || "",
        name: `${this.allData.step2?.firstName || ""} ${
          this.allData.step2?.firstLastName || ""
        } ${this.allData.step2?.secondLastName || ""}`.trim(),
        location: cleanLocationName(this.allData.step2?.preferredLocation?.name) || "",
      };
    },
    groupedCourses() {
      // Usar el mismo sistema de colores que el paso 3
      const map = {};
      (this.allData.step3?.selectedCourses || []).forEach((c) => {
        // Obtener el subjectName correcto para usar el mismo color que en el paso 3
        const subjectName = this.getSubjectNameByCourseId(c.id || c.courseId);
        
        // Obtener la materia (Subject) a la que pertenece el curso - MISMA LÓGICA QUE COURSESELECTOR
        const materia = this.findMateriaByCourseId(c.id || c.courseId);
        const originalSubjectName = materia?.subjectName || c.subjectName || c.name || '';
        
        // Detectar etiquetas basándose en el nombre del curso - MISMA LÓGICA QUE COURSESELECTOR
        const courseName = c.name || '';
        const hasMention = /MENCIÓN/gi.test(courseName) || /Mención/gi.test(courseName);
        const isElective = /ELECTIVO/gi.test(courseName) || /Electivo/gi.test(courseName);
        const isCommon = /COMÚN/gi.test(courseName) || /Común/gi.test(courseName);
        
        // Crear objeto curso con etiquetas basadas en el nombre - MISMA LÓGICA QUE COURSESELECTOR
        const courseWithLabels = {
          ...c,
          hasMention: hasMention,
          isElective: isElective,
          isCommon: isCommon
        };
        
        // Usar utilidad compartida para formatear nombre completo - MISMA LÓGICA QUE COURSESELECTOR
        const fullName = formatFullCourseName(originalSubjectName, courseWithLabels);
        
        // Agrupar solo por nombre del curso (sin hora)
        const key = fullName;
        
        if (!map[key]) {
          map[key] = {
            name: fullName,
            schedules: [],
            color: courseColorsStore.getCourseColor(c.id || c.courseId, subjectName),
          };
        }
        
        // Agregar horario formateado
        if (c.schedule) {
          const [day, hour] = c.schedule.split(" ");
          const formattedSchedule = `${day} de ${hour.split('-')[0]} a ${hour.split('-')[1]}`;
          map[key].schedules.push(formattedSchedule);
        }
      });
      
      // Devolver array de cursos agrupados
      return Object.values(map).map((c) => ({
        name: c.name,
        schedules: c.schedules,
        color: c.color,
      }));
    },
    pricing() {
      const precioBruto = this.quote?.precioBruto || 0;
      const valorDescuentoSesiones = this.quote?.valorDescuentoSesiones || 0;
      const precioSubTotal = this.quote?.precioSubTotal || 0;
      const valorDescuento = this.quote?.valorDescuento || 0;
      const valorMatricula = this.quote?.valorMatricula || 0;
      const valorCupon = this.quote?.valorCupon || 0;
      const precioTotal = this.quote?.precioTotal || 0;
      
      // Calcular porcentajes
      const porcentajeDescuentoSesiones = precioBruto > 0 ? Math.round((valorDescuentoSesiones / precioBruto) * 100) : 0;
      const porcentajeDescuento = precioSubTotal > 0 ? Math.round((valorDescuento / precioSubTotal) * 100) : 0;
      
      // Calcular total de descuentos
      const totalDescuento = valorDescuentoSesiones + valorDescuento + valorCupon;
      
      // Calcular porcentaje total de descuento (EXCLUYENDO cupones)
      // Solo incluye descuentos por sesiones y matrícula online
      const porcentajeTotalDescuento = (() => {
        // Calcular el total de descuentos (sin incluir cupones)
        const totalDescuentosSinCupon = valorDescuentoSesiones + valorDescuento;
        
        // Calcular el porcentaje total como: (total descuentos / precio bruto) * 100
        const porcentaje = precioBruto > 0 ? Math.round((totalDescuentosSinCupon / precioBruto) * 100) : 0;
        
        return porcentaje;
      })();

      return {
        precioBruto,
        valorDescuentoSesiones,
        precioSubTotal,
        valorDescuento,
        valorMatricula,
        valorCupon,
        precioTotal,
        porcentajeDescuentoSesiones,
        porcentajeDescuento,
        totalDescuento,
        porcentajeTotalDescuento,
      };
    },
    calendarSelectedCourses() {
      // Mapear los cursos seleccionados del resumen a la estructura que espera WeeklyCalendar
      const result = [];
      (this.allData.step3?.selectedCoursesRaw || []).forEach((sel) => {
        // Validar que existan ambos IDs
        if (sel.courseId && sel.scheduleId) {
          result.push({ courseId: sel.courseId, scheduleId: sel.scheduleId });
        }
      });
      return result;
    },
    isFreeOrder() {
      // Verificar si la orden es gratuita basándose en el precio total
      const precioTotal = this.quote?.precioTotal || 0;
      return precioTotal === 0 || precioTotal === '0';
    },
    buttonText() {
      return this.isFreeOrder ? 'Confirmar Matrícula' : 'Ir a matricular';
    },
  },
  methods: {
    
    getSubjectNameByCourseId(courseId) {
      // Buscar en las materias del paso 3 para obtener el subjectName correcto
      const allMaterias = [
        ...(this.allData.step3?.leftColumnMaterias || []),
        ...(this.allData.step3?.rightColumnMaterias || [])
      ];
      
      for (const materia of allMaterias) {
        if (materia.courses) {
          const course = materia.courses.find(c => c.id == courseId);
          if (course) {
            return materia.subjectName;
          }
        }
      }
      
      // Fallback: buscar en los cursos seleccionados
      const selectedCourse = this.allData.step3?.selectedCourses?.find(c => 
        (c.id || c.courseId) == courseId
      );
      
      return selectedCourse?.subjectName || selectedCourse?.name || '';
    },
    
    findMateriaByCourseId(courseId) {
      // Buscar en las materias del paso 3 para obtener la materia que contiene el curso
      const allMaterias = [
        ...(this.allData.step3?.leftColumnMaterias || []),
        ...(this.allData.step3?.rightColumnMaterias || [])
      ];
      
      for (const materia of allMaterias) {
        if (materia.courses) {
          const course = materia.courses.find(c => c.id == courseId);
          if (course) {
            return materia;
          }
        }
      }
      
      return null;
    },
    
    getFullCourseById(courseId) {
      // Buscar en las materias del paso 3 para obtener el curso completo con etiquetas
      const allMaterias = [
        ...(this.allData.step3?.leftColumnMaterias || []),
        ...(this.allData.step3?.rightColumnMaterias || [])
      ];
      
      for (const materia of allMaterias) {
        if (materia.courses) {
          const course = materia.courses.find(c => c.id == courseId);
          if (course) {
            return {
              ...course,
              hasMention: materia.hasMention || false,
              isElective: materia.isElective || false,
              isCommon: materia.isCommon || false
            };
          }
        }
      }
      
      // Fallback: buscar en los cursos seleccionados
      const selectedCourse = this.allData.step3?.selectedCourses?.find(c => 
        (c.id || c.courseId) == courseId
      );
      
      return selectedCourse || null;
    },
    formatPrice(price) {
      return price.toLocaleString("es-CL");
    },
    getCouponDiscountPercentage() {
      // Detectar específicamente cupones del 100% - PRIORIDAD MÁXIMA
      if (this.appliedCoupon && this.appliedCoupon.toUpperCase().includes('100')) {
        return 100;
      }
      
      if (this.precioOriginalSinCupon && this.quote?.precioTotal) {
        const descuento = this.precioOriginalSinCupon - this.quote.precioTotal;
        
        // Si el precio total es 0, es un cupón del 100%
        if (this.quote.precioTotal === 0) {
          return 100;
        }
        
        // Si el descuento es igual al precio original, es 100%
        if (this.precioOriginalSinCupon > 0 && descuento >= this.precioOriginalSinCupon) {
          return 100;
        }
        
        // Calcular el subtotal después del primer descuento (matrícula online)
        const precioSubTotal = this.quote?.precioSubTotal || 0;
        const valorDescuento = this.quote?.valorDescuento || 0;
        const subtotalDespuesPrimerDescuento = precioSubTotal - valorDescuento;
        
        // El porcentaje del cupón debe calcularse sobre el subtotal restante
        const porcentaje = subtotalDespuesPrimerDescuento > 0 ? 
          Math.round((descuento / subtotalDespuesPrimerDescuento) * 100) : 0;
        return porcentaje;
      }
      return 0;
    },
    getCouponDiscountAmount() {
      if (this.precioOriginalSinCupon && this.quote?.precioTotal) {
        const descuento = this.precioOriginalSinCupon - this.quote.precioTotal;
        
        return descuento;
      }
      return 0;
    },
    async applyCoupon() {
      if (!this.couponCode.trim()) {
        return;
      }

      this.isValidating = true;
      this.couponError = false;

      try {
        // Agregar un pequeño delay para mostrar el loader elegante
        await new Promise(resolve => setTimeout(resolve, 600));
        
        // Validar cupón con la API
        const isValid = await this.validateCouponWithAPI(this.couponCode);
        
        if (isValid) {
          // Guardar el precio original antes de aplicar el cupón
          this.precioOriginalSinCupon = this.quote?.precioTotal || 0;
          
          this.appliedCoupon = this.couponCode;
          this.couponCode = "";
          
          // Guardar en el store
          this.stepperStore.updateStep4({
            coupon: this.appliedCoupon,
            precioOriginalSinCupon: this.precioOriginalSinCupon
          });
          
          // Recargar la cotización con el cupón aplicado
          await this.reloadQuoteWithCoupon();
          
          // Emitir evento para actualizar el componente padre
          this.$emit('coupon-applied', {
            coupon: this.appliedCoupon,
            isValid: true
          });
        } else {
          this.couponError = true;
          this.appliedCoupon = null;
        }
      } catch (error) {
        console.error("Error applying coupon:", error);
        this.couponError = true;
        this.appliedCoupon = null;
      } finally {
        this.isValidating = false;
      }
    },

    async validateExistingCoupon() {
      
      if (!this.appliedCoupon) {
        return;
      }

      // Mostrar estado de validación
      this.isValidating = true;
      this.couponError = false;

      try {
        // Agregar un pequeño delay para mostrar el loader elegante
        await new Promise(resolve => setTimeout(resolve, 800));
        
        // Usar el método existente para validar
        const isValid = await this.validateCouponWithAPI(this.appliedCoupon);
        
        if (isValid) {
          
          // Guardar el precio original antes de aplicar el cupón (si no existe)
          if (!this.precioOriginalSinCupon) {
            this.precioOriginalSinCupon = this.quote?.precioTotal || 0;
          }
          
          // Guardar en el store
          this.stepperStore.updateStep4({
            coupon: this.appliedCoupon,
            precioOriginalSinCupon: this.precioOriginalSinCupon
          });
          
          // Recargar la cotización con el cupón aplicado
          await this.reloadQuoteWithCoupon();
          
          // Emitir evento para actualizar el componente padre (igual que validación manual)
          this.$emit('coupon-applied', {
            coupon: this.appliedCoupon,
            isValid: true
          });
        } else {
          
          // Mostrar error igual que validación manual
          this.couponError = true;
          
          // Mover el cupón inválido al campo de entrada para que el usuario lo vea
          this.couponCode = this.appliedCoupon;
          this.appliedCoupon = null;
          this.precioOriginalSinCupon = null; // Limpiar precio original
          
          // Actualizar store eliminando el cupón inválido
          this.stepperStore.updateStep4({ coupon: null });
          this.stepperStore.saveToLocalStorage();
          
          // Recargar cotización sin cupón
          await this.reloadQuoteWithCoupon();
          
          this.$emit('coupon-removed');
        }
      } catch (error) {
        console.error('Error validating existing coupon:', error);
        
        // En caso de error, mostrar error igual que validación manual
        this.couponError = true;
        this.couponCode = this.appliedCoupon;
        this.appliedCoupon = null;
        this.precioOriginalSinCupon = null; // Limpiar precio original
        
        // Actualizar store y recargar cotización sin cupón
        this.stepperStore.updateStep4({ coupon: null });
        this.stepperStore.saveToLocalStorage();
        await this.reloadQuoteWithCoupon();
        
        this.$emit('coupon-removed');
      } finally {
        this.isValidating = false;
      }
    },

    async validateCouponWithAPI(couponCode) {
      try {
        // Obtener datos necesarios para la cotización
        const locationId = this.allData.step2?.preferredLocation?.id;
        const programId = this.allData.step1?.program?.id;
        const coursesIds = this.allData.step3?.selectedCourses
          ?.map((course) => course.id || course.courseId)
          .join(",");
        const studentId = this.allData.step2?.studentId;
        const orderId = this.allData.step2?.orderId;

        // Usar getQuote para validar el cupón
        const response = await quoteService.getQuote({
          locationId,
          programId,
          coursesIds,
          studentId,
          orderId,
          coupon: couponCode,
        });

        return response.validCupon || false;
      } catch (error) {
        console.error("API validation error:", error);
        return false;
      }
    },

    async reloadQuoteWithCoupon() {
      try {
        // Obtener datos necesarios para la cotización
        const locationId = this.allData.step2?.preferredLocation?.id;
        const programId = this.allData.step1?.program?.id;
        const coursesIds = this.allData.step3?.selectedCourses
          ?.map((course) => course.id || course.courseId)
          .join(",");
        const studentId = this.allData.step2?.studentId;
        const orderId = this.allData.step2?.orderId;

        // Llamar a la API con el cupón actual (puede ser null para remover)
        const newQuote = await quoteService.getQuote({
          locationId,
          programId,
          coursesIds,
          studentId,
          orderId,
          coupon: this.appliedCoupon || null,
        });

        // Actualizar tanto el cupón como la cotización en el store
        this.stepperStore.updateStep4({
          quote: newQuote,
          coupon: this.appliedCoupon,
          precioOriginalSinCupon: this.precioOriginalSinCupon
        });

        // Guardar en localStorage
        this.stepperStore.saveToLocalStorage();

        // Emitir evento para actualizar el componente padre
        this.$emit("quote-updated", newQuote);
      } catch (error) {
        console.error("Error reloading quote:", error);
        throw error;
      }
    },

    removeCoupon() {
      this.appliedCoupon = null;
      this.precioOriginalSinCupon = null; // Limpiar precio original
      this.couponCode = "";
      this.couponError = false;

      // Limpiar del store
      this.stepperStore.updateStep4({
        coupon: null,
        precioOriginalSinCupon: null
      });

      // Recargar cotización sin cupón
      this.reloadQuoteWithCoupon();

      // Emitir evento
      this.$emit("coupon-removed");
    },
    goToPreviousStep() {
      this.$emit("previous-step");
    },
    goToNextStep() {
      this.$emit("next-step");
    },


    

  },
  components: {
    WeeklyCalendar,
    PdfGenerator,
  },
};
</script>

<style scoped>
/* Exact same styles as CourseSelector */
.course-selection {
  padding: 20px;
  max-width: 936px;
  margin: 0 auto;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  box-sizing: border-box;
  overflow-x: hidden;
}

.icon {
  width: 24px;
  height: 24px;
  color: black;
}

.header-section {
  text-align: left;
  margin-bottom: 40px;
}

.main-title {
  font-family: "Poppins-Medium" !important;
  font-size: 2.5rem;
  font-weight: 100;
  color: #333;
  margin: 0 0 10px 0;
}

.subtitle {
  font-size: 1.2rem;
  color: #666;
  margin: 0;
}

/* Main Content Box - Exact same as CourseSelector */
.content-box {
  position: relative;
  border-radius: 20px;
  margin-bottom: 30px;
  background-color: white;
  box-sizing: border-box;
  overflow-x: hidden;
}


/* Main Content Grid */
.main-content {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 30px;
}

/* Hacer que details-section sea flexbox para usar order */
.details-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Info Card */
.info-card {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.info-icon {
  width: 16px;
  height: 16px;
  color: #666;
  flex-shrink: 0;
  margin-top: 2px;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-label {
  font-family: "Poppins-Medium" !important; 
  font-weight: 400 !important;
  font-size: 1rem;
  color: #666;
}

.info-value {
  font-weight: 100;
  color: #333;
  font-size: 1rem;
}

/* Courses Section */
.courses-section {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
}

.section-title {
  font-family: "Poppins-Medium";
  font-size: 1.5rem;
  font-weight: 100;
  color: #333;
  margin: 0 0 16px 0;
}

.courses-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.course-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.course-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.course-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.course-dot.bg-teal {
  background-color: #10b981;
}

.course-dot.bg-orange {
  background-color: #f59e0b;
}

.course-name {
  font-weight: 100;
  color: #333;
  font-size: 1rem;
}

.course-schedules {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 20px;
}

.course-schedule-item {
  font-size: 0.95rem;
  color: #666;
}

/* Pricing Section */
.pricing-section {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  overflow-x: hidden;
}

.pricing-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  flex-wrap: wrap;
  gap: 8px;
}

.pricing-item.discount .pricing-label,
.pricing-item.discount .pricing-value {
  color: #575857;
  font-size: 1rem;
}

.pricing-item.total-discount .pricing-label,
.pricing-item.total-discount .pricing-value {
  color: #171818;
  font-size: 1rem;
  font-weight: 100;
}

.pricing-item.coupon-discount .pricing-label,
.pricing-item.coupon-discount .pricing-value {
  color: #2e2f2f;
  font-size: 1rem;
  font-weight: 500;
}

.pricing-item.monto-programa {
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid #ddd;
}

.pricing-item.monto-programa .pricing-label,
.pricing-item.monto-programa .pricing-value {
  color: #171818;
  font-size: 1.1rem;
  font-weight: 100;
}

.pricing-item.total {
  margin-top: 8px;
  padding-top: 16px;
}

.pricing-label {
  color: #666;
  font-size: 1rem;
  flex: 1;
  min-width: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.pricing-value {
  font-weight: 100;
  color: #333;
  font-size: 1rem;
  flex-shrink: 0;
  text-align: right;
}

.pricing-divider {
  border-top: 1px solid #ddd;
  margin: 16px 0 8px 0;
}

.pricing-note {
  font-size: 1rem;
  color: #666;
  margin: 8px 0;
  padding: 0;
  line-height: 1.4;
}

.pricing-note strong {
  font-weight: 700;
  color: #3b3b3b;
}

/* Summary Section */
.summary-section {
  display: flex;
  flex-direction: column;
}

.summary-card {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  position: sticky;
}

/* Why Choose Us Section */
.why-choose-card {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
  box-sizing: border-box;
}

.why-choose-card .section-title {
  margin-bottom: 16px;
  text-align: left;
}

.why-choose-list {
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.why-choose-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
  font-size: 0.95rem;
  color: #333;
  line-height: 1.6;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  min-height: 1.6em;
}

.why-choose-list li span {
  font-size: 0.95rem;
}

.why-choose-icon {
  flex-shrink: 0;
  flex-grow: 0;
  width: 24px;
  min-width: 24px;
  max-width: 24px;
  height: 24px;
  object-fit: contain;
  margin-top: 2px;
  filter: brightness(0) saturate(100%) invert(42%) sepia(93%) saturate(1352%) hue-rotate(187deg) brightness(97%) contrast(89%);
}

.why-choose-list li span {
  flex: 1;
  display: block;
}

/* Total Section */
.total-section {
  display: flex;
  flex-direction: column;
}

.total-label {
  font-size: 1rem;
  color: #666;
  margin-bottom: 8px;
  align-self: flex-start;
}

.total-amount {
  font-size: 2rem;
  font-weight: 100;
  color: #333;
}

.original-price {
  display: block;
}

.original-amount {
  font-size: 1.5rem;
  color: #666;
  text-decoration: line-through;
  font-weight: normal;
  display: block;
}

/* Tag de descuento aplicado */
.discount-tag {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f0f8f0;
  border: 1px solid #10b981;
  border-radius: 20px;
  padding: 8px 16px;
  margin-bottom: 12px;
  width: fit-content;
  align-self: flex-end;
}

.discount-icon {
  width: 16px;
  height: 16px;
  background-color: #10b981;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.discount-icon svg {
  width: 10px;
  height: 10px;
  color: white;
}

.discount-text {
  font-size: 0.9rem;
  font-weight: 100;
  color: #10b981;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Coupon Section */
.coupon-section {
  border-top: 1px solid #ddd;
  padding-top: 20px;
}

.coupon-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.coupon-icon {
  width: 16px;
  height: 16px;
  color: #666;
}

.coupon-title {
  font-weight: 100;
  color: #333;
  font-size: 1rem;
}

.coupon-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.coupon-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.coupon-label {
  font-size: 1rem;
  color: #666;
}

.coupon-input {
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
  outline: none;
}

.coupon-input:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
}

.coupon-input::placeholder {
  color: #999;
}

.coupon-button {
  padding: 12px 20px;
  background: #d8d8d8;
  color: #333;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.coupon-button:hover:not(:disabled) {
  background: #787272;
}

.coupon-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
}

.applied-coupon {
  margin-top: 16px;
}

.coupon-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 8px;
}

.coupon-code {
  font-weight: 100;
  color: #155724;
  font-size: 1rem;
}

.remove-coupon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.remove-coupon-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.remove-coupon-btn img {
  width: 16px;
  height: 16px;
  filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%)
    hue-rotate(86deg) brightness(104%) contrast(97%);
}

/* Coupon Validation Loader */
.coupon-validating {
  margin-top: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 2px solid #e9ecef;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #e9ecef;
  border-top: 3px solid #4a90e2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.validating-text {
  font-size: 1rem;
  color: #4a90e2;
  font-weight: 500;
  letter-spacing: 0.5px;
}

@keyframes pulse {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

.validating-text {
  animation: pulse 1.5s ease-in-out infinite;
}

/* Additional Confirm Button Section */
.additional-confirm-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.additional-confirm-section p {
  margin: 0;
  text-align: center;
  font-size: 0.95rem;
  color: #666;
}

.additional-confirm-btn {
  background: #111;
  color: #fff;
  border: none;
  border-radius: 24px;
  padding: 12px 30px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
  min-width: 160px;
}

.additional-confirm-btn:hover {
  background: #333;
  transform: translateY(-1px);
}

.additional-confirm-btn:active {
  transform: translateY(0);
}


@media (max-width: 991px) {
  .hidden-mobile {
    display: none !important;
  }
}

/* Calendar Section */
.calendar-section {
  margin-top: 30px;
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.calendar-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

/* Botones de navegación */
.nav-btns {
  display: flex;
  justify-content: center;
  gap: 18px;
  margin: 28px 0 18px 0;
}

.back-btn,
.continue-btn {
  border: none;
  border-radius: 24px;
  padding: 10px 26px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  background: #f5f5f5;
  color: #888;
  transition: background 0.2s, color 0.2s;
}

.back-btn:hover {
  background: #e0e0e0;
  color: #666;
}

/* Botón continuar habilitado: fondo negro, texto blanco */
.continue-btn:enabled {
  background: #111;
  color: #fff;
}

.continue-btn:enabled:hover {
  background: #333;
}

.continue-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: #111;
  color: #fff;
}

/* Responsive Design - Same as CourseSelector */
@media (max-width: 768px) {
  .course-selection {
    padding: 15px;
    overflow-x: hidden;
  }
  
  /* Cambiar orden de botones en mobile */
  .nav-btns {
    flex-direction: column;
    gap: 12px;
  }
  
  .continue-btn {
    order: -1;
  }
  
  .back-btn {
    order: 1;
  }

  .main-title {
    font-size: 2rem;
    line-height: 1.2;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .subtitle {
    font-size: 1.1rem;
    line-height: 1.3;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .content-box {
    padding: 25px 20px;
    border-radius: 16px;
    overflow-x: hidden;
  }

  .main-content {
    display: flex;           /* ← Cambiar de grid a flexbox en mobile */
    flex-direction: column;  /* ← Dirección vertical */
    gap: 20px;
    overflow-x: hidden;
    position: relative;      /* ← Para posicionamiento absoluto */
  }

  .summary-card {
    position: static;
  }
  
  .header-section {
    margin-bottom: 30px;
  }
  
  .info-card,
  .courses-section,
  .pricing-section {
    padding: 16px;
    overflow-x: hidden;
  }
  
  /* Reposicionar importante-section en mobile usando position */
  .importante-section {
    position: absolute;
    top: 100%;              /* ← Después del main-content */
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
    padding: 12px;
    box-sizing: border-box;
    overflow-x: hidden;
    margin-top: 20px;       /* ← Espacio después del summary */
  }
  
  .section-title {
    font-size: 1.3rem;
    margin-bottom: 12px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .info-item {
    gap: 12px;
    flex-wrap: wrap;
  }
  
  .info-icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
  
  .info-content {
    flex: 1;
    min-width: 0;
  }
  
  .info-label,
  .info-value {
    font-size: 0.95rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .course-group {
    gap: 6px;
  }
  
  .course-header {
    gap: 8px;
  }
  
  .course-name {
    font-size: 0.95rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .course-schedules {
    margin-left: 16px;
  }
  
  .course-schedule-item {
    font-size: 0.9rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .pricing-item {
    padding: 10px 0;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
  
  .pricing-label,
  .pricing-value {
    font-size: 0.95rem;
    flex: 1;
    min-width: 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .pricing-value {
    text-align: right;
    font-weight: 100;
    flex-shrink: 0;
  }
  
  .total-amount {
    font-size: 1.8rem;
  }
  
  .original-amount {
    font-size: 1.3rem;
  }
  
  .discount-tag {
    padding: 6px 12px;
    margin-bottom: 10px;
    width: 100%;
    justify-content: center;
  }
  
  .discount-text {
    font-size: 0.85rem;
  }
  
  .coupon-section {
    padding-top: 16px;
  }
  
  .coupon-title {
    font-size: 0.95rem;
  }
  
  .coupon-input {
    padding: 10px 14px;
    font-size: 0.95rem;
    width: 100%;
    box-sizing: border-box;
  }
  
  .coupon-button {
    padding: 10px 18px;
    font-size: 0.95rem;
    width: 100%;
  }
  
  .additional-confirm-btn {
    padding: 11px 26px;
    font-size: 0.95rem;
    min-width: 150px;
  }
  
  .importante-section {
    width: 100%;
    height: auto;
    padding: 12px;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  
  .importante-section h5 {
    font-size: 0.95rem;
    padding-bottom: 8px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .importante-section p {
    font-size: 0.85rem;
    line-height: 1.4;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
}

@media (max-width: 480px) {
  .course-selection {
    padding: 12px;
    overflow-x: hidden;
  }
  
  .main-content {
    display: flex;           /* ← Cambiar de grid a flexbox en mobile */
    flex-direction: column;  /* ← Dirección vertical */
    gap: 16px;
    overflow-x: hidden;
    position: relative;      /* ← Para posicionamiento absoluto */
  }
  
  /* Reposicionar importante-section en mobile usando position */
  .importante-section {
    position: absolute;
    top: 100%;              /* ← Después del main-content */
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
    overflow-x: hidden;
    margin-top: 16px;       /* ← Espacio después del summary */
  }
  
  .main-title {
    font-size: 1.8rem;
    line-height: 1.2;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .subtitle {
    font-size: 1rem;
    line-height: 1.3;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .content-box {
    padding: 20px 16px;
    border-radius: 12px;
    overflow-x: hidden;
  }
  
  .main-content {
    gap: 16px;
    overflow-x: hidden;
  }
  
  .header-section {
    margin-bottom: 24px;
  }
  
  .info-card,
  .courses-section,
  .pricing-section,
  .summary-card,
  .why-choose-card {
    padding: 14px;
    overflow-x: hidden;
  }
  
  .section-title {
    font-size: 1.2rem;
    margin-bottom: 10px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .why-choose-list li {
    font-size: 0.95rem;
    line-height: 1.5;
    padding: 10px 0;
    gap: 10px;
    min-height: 1.5em;
  }

  .why-choose-list li span {
    font-size: 0.95rem;
  }

  .why-choose-icon {
    width: 20px;
    min-width: 20px;
    max-width: 20px;
    height: 20px;
    margin-top: 1px;
  }
  
  .info-item {
    gap: 10px;
    flex-wrap: wrap;
  }
  
  .info-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
  
  .info-content {
    flex: 1;
    min-width: 0;
  }
  
  .info-label,
  .info-value {
    font-size: 0.9rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .course-item {
    gap: 8px;
    flex-wrap: wrap;
  }
  
  .course-name {
    font-size: 0.9rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .course-schedule {
    font-size: 0.85rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .pricing-item {
    padding: 8px 0;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
  
  .pricing-label,
  .pricing-value {
    font-size: 0.9rem;
    flex: 1;
    min-width: 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .pricing-value {
    text-align: right;
    font-weight: 100;
    flex-shrink: 0;
  }
  
  .total-amount {
    font-size: 1.6rem;
  }
  
  .original-amount {
    font-size: 1.2rem;
  }
  
  .discount-tag {
    padding: 5px 10px;
    margin-bottom: 8px;
    width: 100%;
    justify-content: center;
  }
  
  .discount-text {
    font-size: 0.8rem;
  }
  
  .coupon-section {
    padding-top: 14px;
  }
  
  .coupon-title {
    font-size: 0.9rem;
  }
  
  .coupon-input {
    padding: 8px 12px;
    font-size: 0.9rem;
    width: 100%;
    box-sizing: border-box;
  }
  
  .coupon-button {
    padding: 8px 16px;
    font-size: 0.9rem;
    width: 100%;
  }
  
  .additional-confirm-btn {
    padding: 10px 24px;
    font-size: 0.95rem;
    min-width: 140px;
  }
  
  .importante-section {
    padding: 10px;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  
  .importante-section h5 {
    font-size: 0.9rem;
    padding-bottom: 6px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .importante-section p {
    font-size: 0.8rem;
    line-height: 1.3;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
}

@media (max-width: 320px) {
  .course-selection {
    padding: 8px;
    overflow-x: hidden;
  }
  
  .main-content {
    display: flex;           /* ← Cambiar de grid a flexbox en mobile */
    flex-direction: column;  /* ← Dirección vertical */
    gap: 14px;
    overflow-x: hidden;
    position: relative;      /* ← Para posicionamiento absoluto */
  }
  
  /* Reposicionar importante-section en mobile usando position */
  .importante-section {
    position: absolute;
    top: 100%;              /* ← Después del main-content */
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
    padding: 8px;
    box-sizing: border-box;
    overflow-x: hidden;
    margin-top: 14px;       /* ← Espacio después del summary */
  }
  
  .main-title {
    font-size: 1.6rem;
    line-height: 1.2;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .subtitle {
    font-size: 0.9rem;
    line-height: 1.3;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .content-box {
    padding: 16px 12px;
    border-radius: 10px;
    overflow-x: hidden;
  }
  
  .main-content {
    gap: 14px;
    overflow-x: hidden;
  }
  
  .header-section {
    margin-bottom: 20px;
  }
  
  .info-card,
  .courses-section,
  .pricing-section,
  .summary-card,
  .why-choose-card {
    padding: 12px;
    overflow-x: hidden;
  }
  
  .section-title {
    font-size: 1.1rem;
    margin-bottom: 8px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .why-choose-list li {
    font-size: 0.95rem;
    line-height: 1.4;
    padding: 8px 0;
    gap: 8px;
    min-height: 1.4em;
  }

  .why-choose-list li span {
    font-size: 0.95rem;
  }

  .why-choose-icon {
    width: 18px;
    min-width: 18px;
    max-width: 18px;
    height: 18px;
    margin-top: 0;
  }
  
  .info-item {
    gap: 8px;
    flex-wrap: wrap;
  }
  
  .info-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
  
  .info-content {
    flex: 1;
    min-width: 0;
  }
  
  .info-label,
  .info-value {
    font-size: 0.85rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .course-item {
    gap: 6px;
    flex-wrap: wrap;
  }
  
  .course-name {
    font-size: 0.85rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .course-schedule {
    font-size: 0.8rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .pricing-item {
    padding: 6px 0;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
  
  .pricing-label,
  .pricing-value {
    font-size: 0.85rem;
    flex: 1;
    min-width: 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .pricing-value {
    text-align: right;
    font-weight: 100;
    flex-shrink: 0;
  }
  
  .total-amount {
    font-size: 1.4rem;
  }
  
  .original-amount {
    font-size: 1.1rem;
  }
  
  .discount-tag {
    padding: 4px 8px;
    margin-bottom: 6px;
    width: 100%;
    justify-content: center;
  }
  
  .discount-text {
    font-size: 0.75rem;
  }
  
  .coupon-section {
    padding-top: 12px;
  }
  
  .coupon-title {
    font-size: 0.85rem;
  }
  
  .coupon-input {
    padding: 6px 10px;
    font-size: 0.85rem;
    width: 100%;
    box-sizing: border-box;
  }
  
  .coupon-button {
    padding: 6px 14px;
    font-size: 0.85rem;
    width: 100%;
  }
  
  .additional-confirm-btn {
    padding: 8px 20px;
    font-size: 0.85rem;
    min-width: 120px;
  }
  
  .importante-section {
    padding: 8px;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  
  .importante-section h5 {
    font-size: 0.85rem;
    padding-bottom: 4px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .importante-section p {
    font-size: 0.75rem;
    line-height: 1.2;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
}

.importante-section {
  width: 100%;
  height: auto;
  background: #FFFAF0;
  border: 1px solid #F1C469;
  border-radius: 8px;
  padding: 15px;
  box-sizing: border-box;
}

/* ===== RESPONSIVE DESIGN COMPLETO ===== */

/* Tablet (768px - 1023px) */
@media (min-width: 769px) and (max-width: 1023px) {
  .course-selection {
    padding: 18px;
  }
  
  .main-title {
    font-size: 2.2rem;
    line-height: 1.2;
  }
  
  .subtitle {
    font-size: 1.15rem;
    line-height: 1.3;
  }
  
  .content-box {
    padding: 28px 25px;
    border-radius: 18px;
  }
  
  .main-content {
    grid-template-columns: 1fr 350px;
    gap: 25px;
  }
  
  .header-section {
    margin-bottom: 35px;
  }
  
  .info-card,
  .courses-section,
  .pricing-section,
  .summary-card,
  .why-choose-card {
    padding: 18px;
  }
  
  .section-title {
    font-size: 1.4rem;
    margin-bottom: 14px;
  }
  
  .info-item {
    gap: 11px;
  }
  
  .info-icon {
    width: 17px;
    height: 17px;
  }
  
  .info-label,
  .info-value {
    font-size: 0.98rem;
  }
  
  .course-item {
    gap: 9px;
  }
  
  .course-name {
    font-size: 0.98rem;
  }
  
  .course-schedule {
    font-size: 0.93rem;
  }
  
  .pricing-item {
    padding: 9px 0;
  }
  
  .pricing-label,
  .pricing-value {
    font-size: 0.98rem;
  }
  
  .total-amount {
    font-size: 1.9rem;
  }
  
  .original-amount {
    font-size: 1.4rem;
  }
  
  .discount-tag {
    padding: 7px 14px;
    margin-bottom: 11px;
  }
  
  .discount-text {
    font-size: 0.88rem;
  }
  
  .coupon-section {
    padding-top: 18px;
  }
  
  .coupon-title {
    font-size: 0.98rem;
  }
  
  .coupon-input {
    padding: 11px 15px;
    font-size: 0.98rem;
  }
  
  .coupon-button {
    padding: 11px 19px;
    font-size: 0.98rem;
  }
  
  .importante-section {
    width: 100%;
    height: auto;
    padding: 14px;
  }
  
  .importante-section h5 {
    font-size: 0.98rem;
    padding-bottom: 9px;
  }
  
  .importante-section p {
    font-size: 0.88rem;
    line-height: 1.4;
  }
}

/* Desktop (1024px - 1279px) */
@media (min-width: 1024px) and (max-width: 1279px) {
  .course-selection {
    padding: 20px;
  }
  
  .main-title {
    font-size: 2.3rem;
    line-height: 1.2;
  }
  
  .subtitle {
    font-size: 1.18rem;
    line-height: 1.3;
  }
  
  .content-box {
    border-radius: 20px;
  }
  
  .main-content {
    grid-template-columns: 1fr 380px;
    gap: 28px;
  }
  
  .header-section {
    margin-bottom: 38px;
  }
  
  .info-card,
  .courses-section,
  .pricing-section,
  .summary-card,
  .why-choose-card {
    padding: 20px;
  }
  
  .section-title {
    font-size: 1.45rem;
    margin-bottom: 15px;
  }
  
  .info-item {
    gap: 12px;
  }
  
  .info-icon {
    width: 18px;
    height: 18px;
  }
  
  .info-label,
  .info-value {
    font-size: 1rem;
  }
  
  .course-item {
    gap: 10px;
  }
  
  .course-name {
    font-size: 1rem;
  }
  
  .course-schedule {
    font-size: 0.95rem;
  }
  
  .pricing-item {
    padding: 10px 0;
  }
  
  .pricing-label,
  .pricing-value {
    font-size: 1rem;
  }
  
  .total-amount {
    font-size: 2rem;
  }
  
  .original-amount {
    font-size: 1.5rem;
  }
  
  .discount-tag {
    padding: 8px 16px;
    margin-bottom: 12px;
  }
  
  .discount-text {
    font-size: 0.9rem;
  }
  
  .coupon-section {
    padding-top: 20px;
  }
  
  .coupon-title {
    font-size: 1rem;
  }
  
  .coupon-input {
    padding: 12px 16px;
    font-size: 1rem;
  }
  
  .coupon-button {
    padding: 12px 20px;
    font-size: 1rem;
  }
  
  .importante-section {
    width: 100%;
    height: auto;
    padding: 15px;
  }
  
  .importante-section h5 {
    font-size: 1rem;
    padding-bottom: 10px;
  }
  
  .importante-section p {
    font-size: 0.9rem;
    line-height: 1.4;
  }
}

/* Large Desktop (1280px+) */
@media (min-width: 1280px) {
  .course-selection {
    padding: 20px;
  }
  
  .main-title {
    font-size: 2.5rem;
    line-height: 1.2;
  }
  
  .subtitle {
    font-size: 1.2rem;
    line-height: 1.3;
  }
  
  .content-box {
    border-radius: 20px;
  }
  
  .main-content {
    grid-template-columns: 1fr 400px;
    gap: 30px;
  }
  
  .header-section {
    margin-bottom: 40px;
  }
  
  .info-card,
  .courses-section,
  .pricing-section,
  .summary-card,
  .why-choose-card {
    padding: 20px;
  }
  
  .section-title {
    font-size: 1.5rem;
    margin-bottom: 16px;
  }
  
  .info-item {
    gap: 12px;
  }
  
  .info-icon {
    width: 18px;
    height: 18px;
  }
  
  .info-label,
  .info-value {
    font-size: 1rem;
  }
  
  .course-item {
    gap: 10px;
  }
  
  .course-name {
    font-size: 1rem;
  }
  
  .course-schedule {
    font-size: 0.95rem;
  }
  
  .pricing-item {
    padding: 10px 0;
  }
  
  .pricing-label,
  .pricing-value {
    font-size: 1rem;
  }
  
  .total-amount {
    font-size: 2rem;
  }
  
  .original-amount {
    font-size: 1.5rem;
  }
  
  .discount-tag {
    padding: 8px 16px;
    margin-bottom: 12px;
  }
  
  .discount-text {
    font-size: 0.9rem;
  }
  
  .coupon-section {
    padding-top: 20px;
  }
  
  .coupon-title {
    font-size: 1rem;
  }
  
  .coupon-input {
    padding: 12px 16px;
    font-size: 1rem;
  }
  
  .coupon-button {
    padding: 12px 20px;
    font-size: 1rem;
  }
  
  .importante-section {
    width: 100%;
    height: auto;
    padding: 15px;
  }
  
  .importante-section h5 {
    font-size: 1rem;
    padding-bottom: 10px;
  }
  
  .importante-section p {
    font-size: 0.9rem;
    line-height: 1.4;
  }
}

/* Landscape Mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .course-selection {
    padding: 12px;
  }
  
  .main-title {
    font-size: 1.8rem;
    margin-bottom: 6px;
  }
  
  .subtitle {
    font-size: 1rem;
    margin-bottom: 6px;
  }
  
  .header-section {
    margin-bottom: 20px;
  }
  
  .content-box {
    padding: 20px;
  }
  
  .main-content {
    gap: 20px;
  }
  
  .info-card,
  .courses-section,
  .pricing-section,
  .summary-card,
  .why-choose-card {
    padding: 15px;
  }
  
  .section-title {
    font-size: 1.2rem;
    margin-bottom: 10px;
  }
}

/* High DPI displays */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .course-selection {
    /* Optimizaciones para pantallas de alta densidad */
  }
  
  .info-icon svg,
  .discount-icon svg {
    /* Mejor renderizado en pantallas de alta densidad */
  }
}

/* Print styles */
@media print {
  .course-selection {
    background: white;
    padding: 20px;
  }
  
  .content-box {
    box-shadow: none;
    border: 1px solid #000;
  }
  
  .summary-card {
    position: static;
  }
  
  .coupon-section.no-pdf {
    display: none;
  }
}

/* Accessibility improvements */
@media (prefers-reduced-motion: reduce) {
  .course-selection {
    /* Reducir animaciones si el usuario lo prefiere */
  }
  
  .coupon-button {
    transition: none;
  }
}

/* Estilos para el PDF - Encabezado y Footer */
.pdf-header {
  width: 100%;
  background: linear-gradient(to bottom, #333 0%, #333 10%, #FFD700 10%, #FFD700 90%, #333 90%, #333 100%);
  padding: 15px 0;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
  page-break-after: avoid;
  break-after: avoid;
}

.header-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.header-text {
  text-align: center;
}

.header-line-1 {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  margin-bottom: 2px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.header-line-2 {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  background: #000;
  padding: 8px 16px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  display: inline-block;
}

.pdf-footer {
  width: 100%;
  background: #f5f5f5;
  border-top: 2px solid #FFD700;
  padding: 15px 0;
  margin-top: 20px;
  text-align: center;
  page-break-before: avoid;
  break-before: avoid;
  page-break-inside: avoid;
  break-inside: avoid;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.footer-line-1 {
  font-size: 12px;
  color: #333;
  font-weight: 500;
}

.footer-icon {
  color: #FF8C00;
  margin: 0 8px;
  font-size: 8px;
}

.footer-line-2 {
  font-size: 11px;
  color: #666;
  font-weight: 400;
}

.footer-line-3 {
  font-size: 12px;
  color: #333;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-icon {
  font-size: 10px;
}

/* Ajustes para orientación horizontal */
@media print {
  .pdf-header {
    page-break-after: avoid;
  }
  
  .pdf-footer {
    page-break-before: avoid;
  }
  
  .content-box {
    page-break-inside: avoid;
  }
}
</style>
